import { MarkCodeTextInputComponent } from './mark-code-text-input.component';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * マークコードテキストボックスManageクラス
 *
 * @export MarkCodeTextInputModel
 * @class MarkCodeTextInputModel
 */
export class MarkCodeTextInputModel {

  public markList = [];

  /** テキストボックスインスタンス */
  public markCodeTextInput: MarkCodeTextInputComponent;
  /** コードリスト取得完了 */
  public completeUpdateMarkCodeList: boolean = <boolean>false;

  /**
   * マークコードリストアップデート
   *
   * @param serverData:サーバから取得された<Data>タグ
   */
  public updateMarkList(serverData: any) {
    if (serverData == null) {
      this.markList = [];
      return;
    }
    this.markList = serverData;

    for (let i: number = <number>0; i < this.markList.length; i++) {
      this.markList[i].MarkCode = PlessViewUtilsSub.padding((this.markList[i].MarkCode + ''), 3, '0', 1);
    }

    this.completeUpdateMarkCodeList = true;
    this.markCodeTextInput.changeMarkCodeHandler();
  }

}
